import { IoMdClose } from 'react-icons/io';
import GalleryGroup from './GalleryGroup';
import './gallery.css';

const Gallery = ({isSetObj, galleries, isSetModal, isPage, isSetPage}) => {

      if(!isPage) return;

      const closeModal = () => {
            isSetPage(false);
      }

      return (
            <div className={(isPage) ? "gallery show" : "gallery"}>
                  <button className="close_gallery" onClick={() => closeModal()}><IoMdClose /></button>
                  <div className="wrapper_gallery">
                        <h2>My Photos Gallery</h2>
                        <GalleryGroup galleries={galleries} isSetObj={isSetObj} isSetModal={isSetModal} />
                  </div>
            </div>
      )
}

export default Gallery;